const OFFICE_READY_TIMEOUT_MS = 5_000;

/**
 * Office.js has occasionally failed to finish its readiness handshake in the
 * Mac task-pane webview. The UI does not need Office APIs to show the login or
 * play browser, so do not leave the React root empty when that happens.
 */
export async function waitForOffice(
  office: Pick<typeof Office, "onReady"> | undefined,
  timeoutMs = OFFICE_READY_TIMEOUT_MS
): Promise<void> {
  if (!office || typeof office.onReady !== "function") {
    return;
  }

  await Promise.race([
    Promise.resolve(office.onReady()).then(() => undefined),
    new Promise<void>((resolve) => window.setTimeout(resolve, timeoutMs)),
  ]).catch((error) => {
    // A failed Office.js handshake should not prevent the task pane from
    // painting. Office-dependent actions will still surface their own errors.
    console.error("[CHLK Office startup]", error);
  });
}
